import React from 'react'
import "./styles/pricing.css"

const Pricing = () => {
  return (
    <div>
      
        
        <div>
        <div>
          <p>Join Our Premium Courses</p>
          <p>Buy standalone courses or get access to all our courses as long as you have an active membership.</p>
        </div>
        <div>
          <div></div>
          <div></div>
        </div>
        </div>
  </div>
  )
}

export default Pricing;